const environment = {
    // apiUrl: 'https://localhost:44368/api/'  // dev local
    apiUrl: 'https://redeem-api.objective-faraday.119-59-118-127.plesk.page/api/'  // dev vps
    // apiUrl: 'https://parking-api.fyi-center.com/api/'  // server
}
export default environment